export function formatNumber(p_number) {
    let number;
    if (typeof(p_number) == 'string') {
        number = parseFloat(p_number);
    } else {
        number = p_number || 0;
    }
    let resp = number.toLocaleString(navigator.language, 
        { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return resp;
}

export function formatNumberSinDecimales(p_number) {
    let number;
    if (typeof(p_number) == 'string') {
        number = parseInt(p_number);
    } else {
        number = p_number || 0;
    }
    let resp = number.toLocaleString(navigator.language, 
        { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return resp;
}